var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUploadIconCloud(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.75 41.25V57C27.75 58.2426 28.7574 59.25 30 59.25C31.2426 59.25 32.25 58.2426 32.25 57V41.25H42C51.0324 41.25 59.25 35.3126 59.25 27C59.25 20.131 53.5827 14.8545 46.5898 13.2592C44.5293 6.03744 37.8843 0.75 30 0.75C22.1157 0.75 15.4707 6.03743 13.4102 13.2592C6.41726 14.8545 0.75 20.131 0.75 27C0.75 35.3126 8.96756 41.25 18 41.25H27.75ZM40.5261 27.6544L31.5261 19.3467C30.6642 18.5511 29.3358 18.5511 28.4739 19.3467L19.4739 27.6544C18.5608 28.4972 18.5038 29.9207 19.3467 30.8338C20.1896 31.7469 21.613 31.8039 22.5261 30.961L27.75 26.139V39C27.75 40.2426 28.7574 41.25 30 41.25C31.2426 41.25 32.25 40.2426 32.25 39V26.139L37.4739 30.961C38.387 31.8039 39.8104 31.7469 40.6533 30.8338C41.4962 29.9207 41.4392 28.4972 40.5261 27.6544Z",
    fill: "#033272"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadIconCloud);
export default __webpack_public_path__ + "static/media/upload-icon-cloud.dac476e19c06bbfb95d019e56991e1bb.svg";
export { ForwardRef as ReactComponent };